
// TBD: create view for each row and make summary view composable instead of ugly onlyTotal option
var SummaryView = (function (BaseView, GetPageTemplate, GlobalSettings, CheckoutSettings) {
	return BaseView.extend({
		el: '@summaryContent',

		initialize: function (opts) {
			_.bindAll(this, 'render', 'handleDeliveryPrice');
			this.listenTo(this.model, 'change', this.render);
			this.listenTo(this.model, 'change', this.handleDeliveryPrice);

			this._onlyTotal = opts && opts.onlyTotal;
            this._shipmentsList = opts && opts.shipmentsList;
            this._shipmentsList.on('add', this.render);
		},

		render: function () {
			var rendered = [];
            var shippingAvailability = this._shipmentsList.shippingAvailability();

            if (shippingAvailability === false) {
                window.app && app.event && app.event.notAvailableDeliverToLocation && app.event.notAvailableDeliverToLocation();
            }

			if (!this._onlyTotal) {
				rendered.push($.tmpl('bt-checkout-summary-row', {
					Name: GetPageTemplate(CheckoutSettings.templateNames.subtotal),
					Value: window.toMoney(this.model.get('Subtotal')),
					Role: 'summarySubtotal'
				}));

                var delivery = this.model.get('Delivery');
                var freeShippingTemplate = $('<span class="nowrap">').html($.tmpl('bt-checkout-summary-row-free-delivery')).html();
                rendered.push($.tmpl('bt-checkout-summary-row', {
                    Name: GetPageTemplate('_TotalsShipping'),
                    Value: (delivery !== null && delivery > 0) ? window.toMoney(delivery) : null,
                    Role: 'summaryDelivery',
                    ShippingAvailability: shippingAvailability,
                    FreeShippingTemplate: freeShippingTemplate
                }));

				if (GlobalSettings.ApplyTax) {
					rendered.push($.tmpl('bt-checkout-summary-row', {
						Name: GetPageTemplate(CheckoutSettings.templateNames.tax),
						Value: window.toMoney(this.model.get('Tax')),
						Role: 'summaryTax'
					}));
                }

                if (!!this.model.get('Select')) {
                    rendered.push($.tmpl('bt-checkout-summary-row', {
                        Name: GetPageTemplate(CheckoutSettings.templateNames.select),
                        Value: window.toMoney(this.model.get('Select')),
                        Role: 'summarySelect'
                    }));
                }

                var prefix = this.model.get('Discount') > 0 ? '- ' : '';
                var discountValue = prefix + window.toMoney(this.model.get('Discount'));

				rendered.push($.tmpl('bt-checkout-summary-row', {
                    Name: 'Discount',
                    Value: discountValue,
					Role: 'summaryVouchers'
				}));
            }


            var title = GetPageTemplate(CheckoutSettings.templateNames.total);
            if (delivery === null) {
                title = 'Total Order (excl. shipping)';
            }

            if (!!this.model.get('Select')) {
                rendered.push($.tmpl('bt-checkout-summary-row', {
                    Name: title,
                    Value: window.toMoney(this.model.get('TotalWithSelect')),
                    Role: 'summaryTotal'
                }));
            }
            else {
                rendered.push($.tmpl('bt-checkout-summary-row-total', {
                    Name: title,
                    Value: window.toMoney(this.model.get('Total')),
                    Role: 'summaryTotal'
                }));
            }

			this.$el.html(rendered);

			return this;
		},

        handleDeliveryPrice: function() {
			var delivery = this.model.get('Delivery');
            if (delivery === null && window.localStorage) {
                var usepostcode = ((JSON.parse(localStorage.getItem('userPostCode')) || '') + '') || null;
                usepostcode && api.getPrices({ Postcode: usepostcode, PickupPoint: '' }).done(this.model._updateCheckout);
            }
        }
	});
})(BaseView, kos.getPageTemplate, GlobalSettings, CheckoutSettings);